import * as Sentry from '@sentry/react'
import createClient from 'openapi-fetch'

import { config } from '~/config/env'
import { LS_JWT_KEY } from '~/const/api'
import { useAccountStore } from '~/stores/account'
import { useSettingsStore } from '~/stores/settings'

import type { paths } from './types'

const baseUrl = config.VITE_NGROK_URL ? `${config.VITE_NGROK_URL}/api` : config.VITE_API_BASE

export const apiClient = createClient<paths>({ baseUrl })

apiClient.use({
  onRequest: ({ request }) => {
    // TODO: research why headers are not propagated by Senty by default
    const traceData = Sentry.getTraceData({ propagateTraceparent: true })
    Object.entries(traceData).forEach(([key, value]) => {
      if (value) request.headers.set(key, value)
    })
    request.headers.set('Authorization', `Bearer ${localStorage.getItem(LS_JWT_KEY)}`)
  },
  onResponse: async ({ response }) => {
    if (response.status === 401 && !response.url.includes('/auth/') && !response.url.includes('/webauthn/')) {
      useAccountStore.getState().clearAccount()
      useSettingsStore.getState().clearSessionSettings()
      location.href = '/auth/login'

      return
    }
  },
})
